import React from 'react'
import {
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  LinearProgress,
  IconButton,
} from '@material-ui/core'
import { Close } from '@material-ui/icons'
import { useFileInfo } from '../../hooks/useFileInfo'

const FileUploadTable = ({ data, setData, filesUploading }) => {
  const handleClick = (id) => {
    const newState = data.filter((x) => x.id !== id)
    setData(newState)
  }

  const UploadRow = ({ file }) => {
    const { fileSize } = useFileInfo(file)

    return (
      <TableRow>
        <TableCell colSpan={4}>
          <div className="file-upload">
            <div className="m-b-10" style={{ color: '#666666' }}>
              {file.name} {fileSize}
            </div>
            <LinearProgress />
          </div>
        </TableCell>
      </TableRow>
    )
  }

  const DataRow = ({ file }) => {
    const { fileSize, fileName, fileType } = useFileInfo(file)

    return (
      <TableRow hover>
        <TableCell>{fileName}</TableCell>
        <TableCell>{fileSize}</TableCell>
        <TableCell>{fileType}</TableCell>
        <TableCell className="actions" align="right">
          <IconButton onClick={() => handleClick(file.id)}>
            <Close />
          </IconButton>
        </TableCell>
      </TableRow>
    )
  }

  return (
    <TableContainer className="scrollable">
      <Table stickyHeader aria-label="sticky table">
        <TableHead>
          <TableRow>
            <TableCell>File</TableCell>
            <TableCell>Size</TableCell>
            <TableCell>Type</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {filesUploading
            .slice(0)
            .reverse()
            .map((file, index) => (
              <UploadRow file={file} key={index} />
            ))}

          {data
            .slice(0)
            .reverse()
            .map((file, index) => (
              <DataRow file={file} key={index} />
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default FileUploadTable
